import i18n from "../i18n";

const { t } = i18n;

const MODAL_TYPES = {
  ITINERARY: t("ITINERARY"),
  IMAGES: t("IMAGES"),
  STATEROOMS: t("STATEROOMS"),
  DECK_PLANS: t("DECK PLANS"),
  CANCELLATION_POLICY: t("CANCELLATION POLICY"),
  PAYMENT: t("PAYMENT"),
  EDIT_CABIN: t("EDIT CABIN"),
  SWITCH_AGENT: t("SWITCH AGENT"),
  CANCEL_BOOKING: t("CANCEL BOOKING"),
};

const MODAL_SIZES = {
  SM: "sm" as const,
  MD: "md" as const,
  LG: "lg" as const,
};

const MODAL = { MODAL_TYPES, MODAL_SIZES };

export default MODAL;
